<template>
  <div
    id="nav"
    class="navbar"
  >
    <span class="menuitem">
      {{ activeMenuItem }}
    </span>
    <div class="links">
      <!-- v-if="isNotEmployee() && clubcardEnabled" -->
      <action-button
        v-if="false"
        action
        variant1
        @click="open"
      >
        Пополнить депозит клиента
      </action-button>

      <div
        v-if="isNotEmployee"
        class="nav-top-balance"
        @click="balanceModal.open"
      >
        <v-icon
          name="wallet"
          height="32"
          width="32"
          class="fs1"
        />
        <span class="balance__value">{{ balanceFormat.format(balance) }}&nbsp;{{ currencySign }}</span>
      </div>
      <account-menu />
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue';
import AccountMenu from './AccountMenu.vue';
import AddBalance from '@/components/UI/modals/AddBalance.vue';
import { getUserState } from '@/firebase';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useModal } from 'vue-final-modal';
import i18n from '@/i18n';
import { getUserById } from '@/services/user.service';
import { getMerchantCurrencySign } from '@/services/merchant.service';
import { getCurrencySign } from '@/utils/currency';

const route = useRoute();
const store = useStore();
const currencySymbol = ref('');
const currencySign = computed(() => getCurrencySign(currencySymbol.value));

const balance = ref(1790.35);
const activeMenuItem = computed(() => i18n.global.t(store.getters.get_menuitem || '_'));

const { open, close } = useModal({
  component: AddBalance,
  attrs: {
    onConfirm() {
      close();
    },
    onClose() {
      close();
    },
  },
  slots: {
    default: '<p>The content of the modal</p>',
  },
});
const balanceFormat = Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const balanceModal = useModal({
  component: AddBalance,
  attrs: {
    onConfirm() {
      balanceModal.close();
    },
    onClose() {
      balanceModal.close();
    },
  },
  slots: {
    default: '<p>The content of the modal</p>',
  },
});
const isNotEmployee = computed(() => false);

onMounted(async () => {
  try {
    const isAuth = await getUserState();
    const userDb = await getUserById(isAuth.uid);
    store.commit('SET_USER', userDb);

    if (route.meta.menuItems) store.commit('SET_MENUITEM', route.meta.menuItems);
  } catch (error) {
    console.log(error);
  }
  await getMerchantCurrencySign(currencySymbol).then(() => {
    // console.log("currentCurrency", currentCurrency.value);
  });
});
</script>

<style lang="scss" scoped>
.navbar {
  // background: var(--color-white) !important;
  z-index: 10;
}

#nav {
  width: 100%;
  height: 64px;
  left: 0px;
  top: 0px;
  // background: var(--color-gray-light);
  display: flex;
  justify-content: space-between;
  position: sticky;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }

  .logo {
    width: 260px;
    min-width: 260px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .links {
    padding: 12px 28px 12px 0px;
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    & > * + * {
      margin-left: 20px;
    }
  }
}

#nav .logo.mobile {
  width: 85px !important;
  min-width: 85px !important;

  &:hover {
    width: 260px;
    min-width: 260px;
  }

  transition: all 0.3s ease;
}

.menuitem {
  display: flex;
  align-items: center;
  padding: 12px 0px 12px 32px;
  color: $primary-color-dark;
  font-family: Montserrat;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  white-space: nowrap;
  overflow: hidden;
  gap: 30px;
}

.temp-info {
  width: 100%;
  text-align: center;
  display: flex;
  gap: 30px;
}

.nav-top-balance {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  color: $primary-color-dark;
  cursor: pointer;
  //styleName: Dashboard/h2;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
</style>
